/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { CmpCedarbubble } from "../CmpCedarbubble";
import { CmpErrorbubble } from "../CmpErrorbubble";
import { CmpSystemlabel } from "../CmpSystemlabel";
import { CmpUserbubble } from "../CmpUserbubble";
import "./style.css";

export const CmpChatmessage = ({
  sender,
  className,
  cmpCedarbubbleDivClassName,
  cmpUserbubbleDivClassName,
  cmpErrorbubbleClassName,
  text = "",
  timestamp = "8:31 AM",
  attachments = [],
  reactions = [],
  isTyping = false,
  isFirstMessage = false,
  status = 'delivered',
  isStreaming = false,  // 🔧 FIX Issue #7: Add isStreaming prop
  onAnimationComplete,  // 🎬 Animation completion callback
}) => {
  return (
    <div className={`cmp-chatmessage ${sender} ${className}`}>
      {sender === "cedar" && (
        <CmpCedarbubble
          className="cmp-cedarbubble-instance"
          divClassName={cmpCedarbubbleDivClassName}
          text={isStreaming ? text : (isTyping ? text : (text || "Hello! How can I help you today?"))}
          enableTyping={isTyping || isStreaming}
          isFirstMessage={isFirstMessage}
          status={status}
          isStreaming={isStreaming}  // 🔧 FIX: Pass isStreaming to CmpCedarbubble
          onAnimationComplete={onAnimationComplete}  // 🎬 Pass callback through
        />
      )}

      {sender === "user" && (
        <CmpUserbubble
          className="instance-node"
          divClassName={cmpUserbubbleDivClassName}
          text={text}
          attachments={attachments}
          reactions={reactions || []}
        />
      )}

      {["cedar", "user"].includes(sender) && (
        <div className="text-wrapper-6">{timestamp}</div>
      )}

      {sender === "system" && (
        <>
          <CmpSystemlabel />
          <div className="text-wrapper-6">{timestamp}</div>
        </>
      )}

      {sender === "error" && (
        <>
          <CmpErrorbubble
            className="instance-node"
            cmpCedarbubbleWrapperDivClassName={cmpErrorbubbleClassName}
          />
          <div className="text-wrapper-6">{timestamp}</div>
        </>
      )}
    </div>
  );
};

CmpChatmessage.propTypes = {
  sender: PropTypes.oneOf(["system", "user", "error", "cedar"]),
  text: PropTypes.string,
  timestamp: PropTypes.string,
  attachments: PropTypes.array,
  isTyping: PropTypes.bool,
  isFirstMessage: PropTypes.bool,
  status: PropTypes.string,
  isStreaming: PropTypes.bool,  // 🔧 FIX Issue #7: Add isStreaming to PropTypes
  onAnimationComplete: PropTypes.func,  // 🎬 Animation completion callback
};
